import { c as _c } from "react/compiler-runtime";
import { useCouponStore } from './useCouponStore.js';
/**
 * Subscribes to selected changes for a given wallet collection.
 *
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @param root0.selector State selector
 * @returns selected value
 */
export function useSubscribedCouponWalletCollection(t0) {
  const $ = _c(3);
  const {
    couponId,
    selector
  } = t0;
  let t1;
  if ($[0] !== couponId || $[1] !== selector) {
    t1 = store => {
      const walletCollection = store.Wallets[couponId];
      return selector(walletCollection);
    };
    $[0] = couponId;
    $[1] = selector;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useCouponStore(t1);
}